import Swiper from "swiper/bundle";

$(document).ready(() => {
    new Swiper(".swiper", {
        grabCursor: true,
        slidesPerView: 1,

        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});
